import { useContext } from 'react';
import { UseQueryResult } from '@tanstack/react-query';

import GenericDataContext from './context';

function useGenericDataContext<T>(): UseQueryResult<T> {
  return useContext(GenericDataContext);
}

export default useGenericDataContext;
